import React from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'

import { Col, Layout, Row } from 'antd'

import { sendEmailForPasswordResetRequired, store } from 'core'
import { ProductIds } from 'core/application/commons/config'

import Button from 'common/components/general/Button'

import InstructionsSentLogo from '../../assets/images/icons/instructions-sent.svg'
import { Notification } from '../../common/components'
import Content from '../../common/components/layout/Content'
import Footer from '../../common/components/layout/Footer'
import { useCommandRequest } from '../../common/hooks'
import useOverrideProduct from '../../common/hooks/useOverrideProduct'
import useUrlQueryParam from '../../common/hooks/useUrlQueryParam'
import { ROUTE_PATHS } from '../../common/routePaths'
import AccountHeader from '../AccountHeader'
import RightSection from '../RightSection'

const SetNewQsehraPassword: React.FC = () => {
  const { t: translate } = useTranslation()

  const history = useHistory()
  const productId = useUrlQueryParam('productId') ?? ProductIds.GroupHraId
  const currentProduct = useOverrideProduct(productId ?? ProductIds.GroupHraId)
  const headerTitle =
    currentProduct.productId == ProductIds.Perks
      ? 'PeopleKeep WorkPerks Management'
      : currentProduct.productId == ProductIds.QsehraId
      ? 'PeopleKeep QSEHRA Customer value'
      : 'PeopleKeep Group Coverage HRA Management'
  const [sendCommand, isCommandLoading] = useCommandRequest()

  const headerItems: string[] = [
    translate('admin-login.subtitle-1'),
    translate('admin-login.subtitle-2'),
    translate('admin-login.subtitle-3'),
  ]

  const onResendEmail = async () => {
    const email = store.getTemporaryEmail()
    const result = await sendCommand(() => sendEmailForPasswordResetRequired(email))
    if (result.completed) {
      Notification.success('Email send')
      store.setTemporaryEmail('')
    }
  }

  return (
    <Layout>
      <Content>
        <Row className="form-content form-content__full-height">
          <Col xs={23} sm={19} md={20} lg={14}>
            <Row justify="center">
              <Col
                span={24}
                sm={{ offset: 3 }}
                xs={{ offset: 1 }}
                md={{ offset: 5 }}
                lg={{ offset: 7 }}
                xl={{ offset: 10 }}
              >
                <div className="pt-16 mb-64">
                  <AccountHeader />
                </div>
              </Col>
            </Row>
            <Row className="mt-64">
              <Col span={24}>
                <Row>
                  <Col
                    sm={{ span: 24, offset: 3 }}
                    xs={{ span: 24 }}
                    md={{ span: 18, offset: 5 }}
                    lg={{ span: 15, offset: 7 }}
                    xl={{ span: 10, offset: 7 }}
                  >
                    <div className="pl-12">
                      <Col xs={24} className="mb-8">
                        <img src={InstructionsSentLogo} alt="instructions-sent-logo" />
                      </Col>
                      <h3>Please check your email</h3>
                      <p className="font-16">
                        Before we can log you in, you need to create a new password. This is to protect your account
                        information.
                      </p>
                      <p className="font-16">
                        {' '}
                        If you have an active account, we have just sent instructions on how to reset your password to
                        your email. Once you have completed that step you will be able to log into the new QSEHRA
                        experience.
                      </p>
                    </div>
                  </Col>
                </Row>
                <Row className="form__row">
                  <div className="pl-12 full-width">
                    <Col
                      sm={{ span: 23, offset: 3 }}
                      xs={{ span: 24 }}
                      md={{ span: 18, offset: 5 }}
                      lg={{ span: 15, offset: 7 }}
                      xl={{ span: 10, offset: 7 }}
                      className="login--login-button mt-40"
                    >
                      <Button
                        type="default"
                        className="button__large"
                        loading={isCommandLoading}
                        disabled={isCommandLoading}
                        onClick={onResendEmail}
                      >
                        Resend email
                      </Button>
                    </Col>
                    <Col
                      sm={{ span: 23, offset: 3 }}
                      xs={{ span: 24 }}
                      md={{ span: 18, offset: 5 }}
                      lg={{ span: 15, offset: 7 }}
                      xl={{ span: 10, offset: 7 }}
                      className="login--login-button mt-16"
                    >
                      <Button
                        type="link"
                        className="button__large"
                        onClick={() => history.push(ROUTE_PATHS.LOGIN_PATH)}
                      >
                        <u>Back to login</u>
                      </Button>
                    </Col>
                  </div>
                </Row>
              </Col>
            </Row>
          </Col>
          <Col xs={0} lg={8} xl={8} className="account-right-section-login">
            <RightSection headerTitle={headerTitle} headerItems={headerItems} />
          </Col>
        </Row>
        <Footer className="absolute" />
      </Content>
    </Layout>
  )
}

export default SetNewQsehraPassword
